export function employeeScheduleRowId(id: string): string {
  return "employee-schedule-row-" + id;
}
